import React from 'react'
import Header from '../Compnents/Main/Header'
import { Outlet } from 'react-router-dom'
import Footer from '../Compnents/Main/Footer'

const Layout = () => {
    return (
        <>
            <Header />
            <Outlet />
            <Footer />
        </>
    )
}

export default Layout